import React, { useCallback, useMemo } from 'react';
import { Button, DateTimePicker, Flex, Selector, Text } from '@leverege/ui-elements';
import { format, parse } from 'date-fns';
import I18N from '@leverege/i18n';
import { HoursRange } from '@leverege/operating-hours';
import S from './RangesEditor.css';
import { getTimeList } from "./Util.js";
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.RangesEditor');
const parseFormats = ['hh:mma', 'h:mma', 'HH:mm', 'HH:m', 'hh:ma', 'h:ma'];
export default function RangesEditor(props) {
  const {
    value,
    model,
    onChange,
    eventData,
    blueprint
  } = props;
  const onDeleteRange = useCallback(evt => {
    const nValue = model.removeAt(value, evt.data);
    onChange({
      value: nValue.ranges,
      data: eventData
    });
  }, [model, value, eventData, onChange]);
  const onAddRange = useCallback(() => {
    const nValue = model.add(value, HoursRange.create());
    onChange({
      value: nValue.ranges,
      data: eventData
    });
  }, [model, value, eventData, onChange]);
  const timeList = useMemo(() => {
    return getTimeList();
  }, []);
  const ranges = model.getAll(value);
  return /*#__PURE__*/React.createElement(Flex, {
    align: "baseline"
  }, /*#__PURE__*/React.createElement("div", {
    className: S.editor
  }, ranges && ranges.length > 0 ? ranges.map((v, index) => {
    const start = HoursRange.getStart(v);
    const end = HoursRange.getEnd(v);
    const onTimeChange = ({
      data,
      value: val
    }) => {
      const time = val;
      const nRange = HoursRange[data](v, time);
      const nValue = model.set(value, index, nRange);
      onChange({
        value: nValue.ranges,
        data: eventData
      });
    };
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `${start}-${end}-${index}`
    }, /*#__PURE__*/React.createElement(Selector, {
      showFilter: true,
      eventData: "setStart",
      className: S.picker,
      onChange: onTimeChange,
      variant: "operatingHoursDay",
      toggleVariant: "operatingHoursDay",
      value: start,
      values: timeList
    }), /*#__PURE__*/React.createElement(Selector, {
      showFilter: true,
      eventData: "setEnd",
      className: S.picker,
      onChange: onTimeChange,
      variant: "operatingHoursDay",
      toggleVariant: "operatingHoursDay",
      value: end,
      values: timeList
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "linkNeutral",
      icon: tIcon('deleteIcon', 'fa fa-fw fa-trash'),
      onClick: onDeleteRange,
      eventData: index
    }));
  }) : /*#__PURE__*/React.createElement(Text, {
    className: S.closed,
    variant: "body"
  }, t('closed', {
    name: blueprint?.name || 'Location'
  }))), /*#__PURE__*/React.createElement(Button, {
    className: S.add,
    onClick: onAddRange,
    variant: "linkNeutral",
    icon: t('addIcon', 'fa fa-fw fa-plus')
  }));
}